module.exports = __webpack_public_path__ + "img/carnetW.59826b24.webp";